import { render, staticRenderFns } from "./nextDisplayBtns.vue?vue&type=template&id=9b4dc1a8"
import script from "./nextDisplayBtns.vue?vue&type=script&lang=js"
export * from "./nextDisplayBtns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports